export enum OrgPlanningPptxExportType {
  Changes = 'Changes',
  SourceTree = 'SourceTree',
  TargetTree = 'TargetTree',
  All = 'All'
}
